import { Button } from '@carbon/react';
import { AddAlt, SubtractAlt } from '@carbon/react/icons';
import { FloatingTooltip } from 'components/floating-tooltip';
import styles from './entity-search-modal.module.scss';

interface EntityRowActionProps {
  isPending: boolean;
  disabled: boolean;
  onAdd: () => void;
  onRemove: () => void;
}

/**
 * A result row's control: add the entity to the selection, or take it back
 * out once added.
 * @param {EntityRowActionProps} props The control.
 * @return {JSX.Element} The control.
 */
export function EntityRowAction({
  isPending,
  disabled,
  onAdd,
  onRemove,
}: EntityRowActionProps) {
  const { label, Icon, onClick } = isPending
    ? { label: 'Remove from selection', Icon: SubtractAlt, onClick: onRemove }
    : { label: 'Select Entity', Icon: AddAlt, onClick: onAdd };

  return (
    <FloatingTooltip
      content={label}
      placement="top"
      asChild
      className={styles.actionTooltip}
    >
      <Button
        kind="ghost"
        hasIconOnly
        iconDescription=""
        aria-label={label}
        size="sm"
        renderIcon={(props) => <Icon size={20} {...props} />}
        onClick={onClick}
        disabled={!isPending && disabled}
      />
    </FloatingTooltip>
  );
}
